// Factory methods to create google maps API objects

/**
 * Creates the Google Maps Map object
 * 
 * @param {object} options - A plain javascript object of options for the map
 * @returns {Map} Google maps Map object
 */
export function createMap(options) {
    return new google.maps.Map(document.getElementById('canvasMap'), options);
}

/**
 * Creates the Google Maps PlacesService object
 * 
 * @param {Google Maps Map object} map - A valid Google Maps Map object
 * @returns {Places Service} Google Maps PlacesService object
 */
export function createPlaces(map) {
    return new google.maps.places.PlacesService(map);
}

/**
 * Creates the Google Maps Autocomplete object
 * 
 * @param {Map} map - A valid Google Maps Map object
 * @param {object} options - A plain javascript object of valid options
 * @param {el} el - Id for element to initialize the autocomplete on
 * @returns {Autocomplete} Google Maps autocomplete object
 */
export function createAddressLoookup(map, options, el) {
    let input = document.getElementById(el);
    let autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.bindTo('bounds', map);
    return autocomplete;
}


// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/maps.js